import { getLocaleSuffix } from "Utils/translationLoader"

export const getNewFilesNotification = ({
  trad,
  filesToUploadETL,
  currentUser,
  recoName,
  controlName,
  recommendationId,
  controlUsersIds,
  associateGroupUsersIds,
}) => {
  if (
    !Array.isArray(filesToUploadETL) ||
    filesToUploadETL?.length === 0 ||
    !currentUser ||
    !recoName ||
    !controlName ||
    !recommendationId ||
    !Array.isArray(controlUsersIds) ||
    !Array.isArray(associateGroupUsersIds)
  ) {
    return null
  }

  const filesNames = filesToUploadETL.map(file => file?.originalName).join(", ")
  const targetUsersIds = [...controlUsersIds, ...associateGroupUsersIds]

  const localeSuffix = `_${getLocaleSuffix(currentUser?.LANGUAGE_ID)}`
  return {
    to_principals: targetUsersIds?.map(id => {
      return `user:${id}`
    }),
    data: {
      event: `${trad?.ADD_DOCUMENTS_TO_RECOMMENDATION} [${recoName}] ${trad?.BELONGING_TO_THE_CONTROL}`,
      elementInBold: controlName,
      redirectUrl: `/recommendation`,
      byUser: `${currentUser.FIRSTNAME} ${currentUser.LASTNAME}`,
      infos: `Documents: ${filesNames}`,
      email: {
        url: "https://pocketstudio.pocketresult.com/",
        event: `${currentUser.FIRSTNAME} ${currentUser.LASTNAME} ${trad?.ASSIGNATION_CONTROLE}`,
      },
      redirect_state: { recommendationId },
    },
    ephemeral: false,
    channel_id: "control_assignment" + localeSuffix,
  }
}
